import { z } from "zod";

export const photoContentType = z.enum(["image/jpeg", "image/png", "image/webp", "image/heic", "image/heif", "image/gif"]);
export type PhotoContentType = z.infer<typeof photoContentType>;

const EXTENSIONS_OF_PHOTO_TYPE: Record<PhotoContentType, readonly [string, ...string[]]> = {
  "image/jpeg": ["jpg", "jpeg"],
  "image/png": ["png"],
  "image/webp": ["webp"],
  "image/heic": ["heic"],
  "image/heif": ["heif"],
  "image/gif": ["gif"],
};

export const PHOTO_FILE_EXTENSIONS: readonly string[] = Object.values(EXTENSIONS_OF_PHOTO_TYPE).flat();

export const photoExtensionOf = (contentType: PhotoContentType): string => EXTENSIONS_OF_PHOTO_TYPE[contentType][0];

export const photoContentTypeOfExtension = (extension: string): PhotoContentType | undefined =>
  photoContentType.options.find((contentType) => EXTENSIONS_OF_PHOTO_TYPE[contentType].includes(extension.toLowerCase()));
